export const shadows = {
  light: '0px 5px 15px rgba(38, 68, 128, 0.05)',
  medium: '0px 5px 15px rgba(122, 133, 153, 0.25)',
  dark: '0px 5px 20px rgba(0, 0, 0, 0.2)',
  color: '0px 5px 20px -5px rgba(233, 52, 94, 0.5)',
};
